import apiClient from './apiClient';
import { ApiResponse, DashboardData } from '../../types/common';

export const getDashboardData = async (): Promise<DashboardData> => {
  const response = await apiClient.get<ApiResponse<DashboardData>>('/admin/dashboard/stats');

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '대시보드 통계 조회에 실패했습니다.');
  }

  return response.data.data;
};

export interface QRStats {
  playstore: {
    total: number;
    allDays: { date: string; count: number }[];
    devices: { mobile: number; desktop: number; other: number };
    topReferrers: { domain: string; count: number }[];
  };
}

export const getQRStats = async (): Promise<QRStats> => {
  const response = await apiClient.get<ApiResponse<QRStats>>('/admin/dashboard/qr-stats');

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error('QR 통계 조회에 실패했습니다.');
  }

  return response.data.data;
};
